<template>
  <div>
    <section class="section-listings pt-4 pb-4">

      <b-container>
        <b-row>
          <b-col cols="12" md="6" class="mb-4">
            <h4 class="section-title d-inline-block">{{ portalConfig.text.topPickListings }}</h4>
          </b-col>
          <b-col cols="12" md="6">
            <b-link to="/SupportDirectory" class="champ-cinema__link d-none d-md-block">View More <font-awesome-icon :icon="['fas', 'caret-right']" /></b-link>
          </b-col>
        </b-row>
        <GetData :endpoint='"articles/" + portalConfig.portalName + "/listings/top-picks" + count + page' :key="componentKeyTPL">
          <GridLayout
            slot-scope="{ response: listing }"
            :result="listing.results"
            :cols="12" :md="6" :lg="3"
            :pagination="true"
            :prevData="listing.previousCursor"
            :nextData="listing.nextCursor"
            @nextListingPage="nextListingpage(listing.nextCursor)"
            @prevListingPage="prevListingPage(listing.previousCursor)" >
          </GridLayout>
        </GetData>
      </b-container>
    </section>
  </div>
</template>

<script>
import GetData from '@/services/GetData'
import GridLayout from '@/components/layout/GridLayout'
import { mapGetters } from 'vuex'

const breakpoints = {
  sm: 540,
  md: 720,
  lg: 960
}

export default {
  name: 'SectionListings',
  props: {
    result: Array,
    breakpoints: Object
  },
  components: {
    GetData,
    GridLayout
  },
  data: () => {
    return {
      componentKeyTPL: 0,
      page: '',
      count: ''
    }
  },
  computed: {
    ...mapGetters({
      portalConfig: 'getPortalConfig'
    })
  },
  created () {
    window.addEventListener('resize', this.resizeHandler)
    this.resizeHandler()
  },
  methods: {
    forceRerender () {
      this.componentKeyTPL += 1
    },
    nextListingpage (next) {
      this.componentKeyTPL++
      this.page = '&next=' + next
    },
    prevListingPage (prev) {
      this.componentKeyTPL++
      this.page = '&previous=' + prev
    },
    resizeHandler (e) {
      const clientWidth = window.innerWidth
      if (clientWidth < breakpoints.md) {
        this.count = '?count=1'
      } else {
        this.count = '?count=4'
      }
    }
  }
}
</script>
